import { LtoPricingRequestCombo, LtoPricingRequestItem } from './lto-pricing.model';

export enum CAMPAIGN_ID {
  national = 'national',
  reinvention = 'reinvention',
  simplified = 'simplified',
  bev_test = 'bev_test',
}

export enum DAYPART {
  breakfast = 'breakfast',
  full_menu = 'full-menu',
}

export enum CONTENT_ID {
  welcome_screen = 'welcome-screen-content',
  marketing_banner = 'marketing-banner-content',
}

export type Campaign = {
  id: string;
  code: string;
  priority: string;
  dayparts: CampaignDaypart[];
};

export type CampaignDaypart = {
  id: string;
  code: string;
  content: CampaignContent[];
};

export type CampaignContent = {
  id: string;
  banners: CampaignBanner[];
};

export type CampaignBanner = {
  id: string;
  imageUrl: string;
  items: CampaignBannerItem[];
  fallbackImageUrl: string;
};

export type CampaignBannerItem = {
  pos: LtoPricingRequestItem | LtoPricingRequestCombo;
  coords?: {
    x: string;
    y: string;
  };
};

export type PricedCampaignBanner = {
  id: string;
  imageUrl: string;
  items: PricedCampaignBannerItem[];
  fallbackEnabled?: boolean;
};

export type PricedCampaignBannerItem = {
  price: string;
  coords?: {
    x: string;
    y: string;
  };
};

export function isCombo(pos: LtoPricingRequestItem | LtoPricingRequestCombo) {
  return (pos as LtoPricingRequestItem).posItemId === undefined;
}
